import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const PREVIEW_DOMAIN_API = '/cos-domains/v1/internal/preview-domain';
const PREVIEW_FORM_URL_API = '_hcms/invoices-template/preview';
const PREVIEW_FORM_URL_API_SIGNED = '_hcms/invoices-template/preview/signed';
export function getPreviewDomain() {
  return http.get(PREVIEW_DOMAIN_API).then(({
    previewDomain
  }) => {
    return previewDomain;
  });
}
export function getPreviewFormUrl(previewDomain, isUngatedForInvoicePreview) {
  if (isUngatedForInvoicePreview) {
    return `https://${previewDomain}/${PREVIEW_FORM_URL_API_SIGNED}?portalId=${PortalIdParser.get()}`;
  }
  return `https://${previewDomain}/${PREVIEW_FORM_URL_API}?portalId=${PortalIdParser.get()}`;
}